import React from 'react';
import * as RT from '../../../constants/Routing.js';
import Form from '../Form';
import { Redirect } from 'react-router-dom';

export default class Component extends React.Component {

  componentWillUnmount = () => {
    this.props.removeCreatedFlag()
  }

  componentWillMount = () => {
  }

  componentWillUnmount = () => {
    this.props.communityCreateReset()
  }

  render = () => {

    if (this.props.Community.createLoaded && !!this.props.Community.community) {
      return (
        <Redirect to={RT.COMMUNITY_EDIT_PATH.replace(/:id/, this.props.Community.community.id)} />
      )
    }


    const currentUser = this.props.App.currentUser
    return (
      <section className='container'>
        <Form title='サークルを作成' currentUser={currentUser} communitySave={this.props.communityCreate} />
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Community/New/New.jsx